import Axios, { AxiosResponse } from 'axios';
import { environment } from '../../environment';
import { errorCatcher } from '../../hooks';
import { useLogin } from '../login';

export interface ITosStatus {
    current_version: string;
    accepted_version: string | null;
    accepted_at: string | null;
    needs_acceptance: boolean;
    /** Warehouse date (YYYY-MM-DD) the backend starts holding orders of brands that have not accepted. */
    holds_start_date: string;
    /** True once that date has arrived and this brand still has not accepted. */
    orders_on_hold: boolean;
}

export type TosAcceptResult = { ok: true; status: ITosStatus } | { ok: false; message: string };

// #region useTermsOfService
/** The brand's Terms of Service acceptance. Brand and user come from the auth token. */
export const useTermsOfService = () => {
    const [, authToken, loginFunctions] = useLogin();

    // #region getStatus
    const getStatus = async (): Promise<ITosStatus | null> => {
        try {
            const response: AxiosResponse<ITosStatus> = await Axios.get(
                `${environment.brandsUrl}/tos-status`,
                { headers: { 'X-Wallmates-Auth': authToken } }
            );
            return response.data;
        } catch (err: any) {
            errorCatcher(err, loginFunctions.logout);
            return null;
        }
    };

    // #region accept
    const accept = async (tosVersion: string): Promise<TosAcceptResult> => {
        try {
            const response: AxiosResponse<ITosStatus> = await Axios.put(
                `${environment.brandsUrl}/tos-acceptance`,
                { tos_version: tosVersion },
                { headers: { 'X-Wallmates-Auth': authToken } }
            );
            return { ok: true, status: response.data };
        } catch (err: any) {
            errorCatcher(err, loginFunctions.logout);
            return { ok: false, message: err?.response?.data?.message || 'We could not record your acceptance. Please try again.' };
        }
    };

    return { getStatus, accept };
};
